<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>

    <b-row>
      <b-form-group  class="col-md-6">
        <label for="name" class="text-capitalize"> روز شروع : </label>
        <b-form-input class="my-custom-editable-input1" type="text" />
        <date-picker
            auto-submit
            clearable
            format="YYYY-MM-DD"
            display-format="jYYYY-jMM-jDD"
            v-model="start_date"
            custom-input=".my-custom-editable-input1"
        />
      </b-form-group>
      <b-form-group  class="col-md-6">
        <label for="name" class="text-capitalize"> روز پایان : </label>
        <b-form-input class="my-custom-editable-input2" type="text" />
        <date-picker
            auto-submit
            clearable
            format="YYYY-MM-DD"
            display-format="jYYYY-jMM-jDD"
            v-model="end_date"
            custom-input=".my-custom-editable-input2"
        />
      </b-form-group>
      <b-button variant="primary" @click="getStatisticsOrder()">
          <span class="text-capitalize">
              جست و جو
            </span>
      </b-button>

    </b-row>

    <div class="d-flex flex-wrap">
      <b-row class="m-1">
        <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
          <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
            آمار اقامتگاه
          </strong>
          <hr/>
          <div class="d-flex">
            <div class="pr-1">
              <strong>مجموع تعداد اقامتگاه ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.total_residence}}

              </b-badge>
              <span>
              تعداد
            </span>
            </div>
          </div>
          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع اقامتگاه فعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.active_residence}}

              </b-badge>
              <span>
              اقامتگاه
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع اقامتگاه غیرفعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="danger">
                {{statisticsOrder.inactive_residence}}

              </b-badge>
              <span>
              اقامتگاه
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_revenue_residence)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_host_revenue_residence">
            <div class="pr-1">
              <strong>مجموع پرداختی به میزبان ها    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_host_revenue_residence)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_site_revenue_residence">
            <div class="pr-1">
              <strong>مجموع درآمد سایت از اقامتگاه    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_site_revenue_residence)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="m-1">
        <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
          <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
            آمار تفریحات
          </strong>
          <hr/>
          <div class="d-flex">
            <div class="pr-1">
              <strong>مجموع تعداد تفریحات ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.total_event}}

              </b-badge>
              <span>
              تعداد
            </span>
            </div>
          </div>
          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع تفریح فعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.active_event}}

              </b-badge>
              <span>
              تفریح
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع تفریح غیرفعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="danger">
                {{statisticsOrder.inactive_event}}

              </b-badge>
              <span>
              تفریح
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_revenue_event)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_host_revenue_event">
            <div class="pr-1">
              <strong>مجموع پرداختی به میزبان ها    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_host_revenue_event)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_site_revenue_event">
            <div class="pr-1">
              <strong>مجموع درآمد سایت از تفریح    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_site_revenue_event)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="m-1">
        <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
          <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
            آمار ترانسفر
          </strong>
          <hr/>
          <div class="d-flex">
            <div class="pr-1">
              <strong>مجموع تعداد ترانسفر ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.total_car}}

              </b-badge>
              <span>
              تعداد
            </span>
            </div>
          </div>
          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع ترانسفر فعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.active_car}}

              </b-badge>
              <span>
              تفریح
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع ترانسفر غیرفعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="danger">
                {{statisticsOrder.inactive_car}}

              </b-badge>
              <span>
              تفریح
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_revenue_car)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_host_revenue_car">
            <div class="pr-1">
              <strong>مجموع پرداختی به میزبان ها    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_host_revenue_car)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_site_revenue_car">
            <div class="pr-1">
              <strong>مجموع درآمد سایت از ترانسفر    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_site_revenue_car)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="m-1">
        <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
          <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
            آمار تور گردشگری
          </strong>
          <hr/>
          <div class="d-flex">
            <div class="pr-1">
              <strong>مجموع تعداد تور گردشگری ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.total_tour}}

              </b-badge>
              <span>
              تعداد
            </span>
            </div>
          </div>
          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع تور فعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{statisticsOrder.active_tour}}

              </b-badge>
              <span>
              تفریح
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع تور غیرفعال ثبت شده :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="danger">
                {{statisticsOrder.inactive_tour}}

              </b-badge>
              <span>
              تور
            </span>
            </div>
          </div>


          <div class="d-flex my-1">
            <div class="pr-1">
              <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_revenue_tour)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_host_revenue_tour">
            <div class="pr-1">
              <strong>مجموع پرداختی به میزبان ها    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_host_revenue_tour)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
          <div class="d-flex my-1" v-if="statisticsOrder.total_site_revenue_tour">
            <div class="pr-1">
              <strong>مجموع درآمد سایت از تور    :</strong>
            </div>
            <div class="mr-2">
              <b-badge variant="success">
                {{numberFormat(statisticsOrder.total_site_revenue_tour)}}

              </b-badge>
              <span>
              تومان
            </span>
            </div>
          </div>
        </div>
      </b-row>
    </div>
    <b-row class="m-1">
      <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمارمجموع درآمدها
        </strong>
        <div v-if="start_date !=''">
          از تاریخ :
          {{
            new Date(start_date)
                .toLocaleString("fa-IR")
                .split("،")[0]
          }}

          تا :
          {{
            new Date(end_date)
                .toLocaleString("fa-IR")
                .split("،")[0]
          }}
        </div>
        <hr/>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل پرداختی به سایت همه خدمات در رزروهای موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{
                numberFormat(
                statisticsOrder.total_revenue_residence
                    +
                    statisticsOrder.total_revenue_event
                    +
                    statisticsOrder.total_revenue_car
                    +
                    statisticsOrder.total_revenue_tour

            )}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1" v-if="statisticsOrder.total_host_revenue_residence">
          <div class="pr-1">
            <strong>مجموع کل  پرداختی به میزبان ها  در همه خدمات  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(
                statisticsOrder.total_host_revenue_residence
                + statisticsOrder.total_host_revenue_event
                + statisticsOrder.total_host_revenue_car
                + statisticsOrder.total_host_revenue_tour
            )}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1" v-if="statisticsOrder.total_site_revenue_residence">
          <div class="pr-1">
            <strong>مجموع درآمد سایت از کل خدمات    :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(
                statisticsOrder.total_site_revenue_residence
                +
                statisticsOrder.total_site_revenue_event
                +
                statisticsOrder.total_site_revenue_car
                +
                statisticsOrder.total_site_revenue_tour

            )}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    BBadge,
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      end_date:'',
      start_date:'',
      perPage: 10,
      page: 1,
      statisticsOrder: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatisticsOrder();
  },

  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    async getStatisticsOrder() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/reports_add_services",
        params: {
          start_date: this.start_date,
          end_date: this.end_date
        }

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statisticsOrder = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
